export { default as ContactEnquiryFormWithFragment } from './contact-enquiry-form-with-fragment';
export { default as ContactEnquiryFormWithQuery } from './contact-enquiry-form-with-query';
